import { render, staticRenderFns } from "./authx-app.vue?vue&type=template&id=0f36b6de"
import script from "./authx-app.vue?vue&type=script&lang=js"
export * from "./authx-app.vue?vue&type=script&lang=js"
import style0 from "./authx-app.vue?vue&type=style&index=0&id=0f36b6de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports